import { DEFAULT_ACCENT_HEX } from '../../lib/brand';
// Tiny dependency-free line chart for catalog cards. points are
// [unixSeconds, value] pairs, oldest first; empty renders an honest "no data".
export function sparkPath(points: [number, number][], w: number, h: number, pad = 4): string {
  if (points.length === 0) return '';
  const ts = points.map((p) => p[0]);
  const vs = points.map((p) => p[1]);
  const t0 = Math.min(...ts);
  const tSpan = Math.max(...ts) - t0 || 1;
  const v0 = Math.min(...vs);
  const vSpan = Math.max(...vs) - v0;
  const x = (t: number) => (points.length === 1 ? w / 2 : pad + ((t - t0) / tSpan) * (w - 2 * pad));
  const y = (v: number) => (vSpan === 0 ? h / 2 : h - pad - ((v - v0) / vSpan) * (h - 2 * pad));
  return points.map((p, i) => `${i ? 'L' : 'M'}${x(p[0]).toFixed(1)} ${y(p[1]).toFixed(1)}`).join(' ');
}

export function Sparkline({
  points,
  color = DEFAULT_ACCENT_HEX,
  label,
}: {
  points?: [number, number][];
  color?: string;
  label: string;
}) {
  const w = 240;
  const h = 64;
  const pts = points ?? [];
  if (pts.length === 0) {
    return <div className="h-16 flex items-center text-[12px] text-black/40 dark:text-white/40">No chart data yet</div>;
  }
  const d = sparkPath(pts, w, h);
  return (
    <svg viewBox={`0 0 ${w} ${h}`} role="img" aria-label={label} className="w-full h-16">
      {pts.length === 1 ? (
        <circle cx={w / 2} cy={h / 2} r={3} fill={color} />
      ) : (
        <path d={d} fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
      )}
    </svg>
  );
}
